/**
 * Tripjack `totalPriceList[].tai.tbi` — per-segment baggage keyed by `sI[].id`.
 * PDF: iB = checked baggage, cB = cabin baggage.
 */

const PAX_PRIORITY = ['ADULT', 'CHILD', 'INFANT'];

function _mergeTbiPaxRow(row) {
  if (!row || typeof row !== 'object') return null;
  for (const p of PAX_PRIORITY) {
    const block = row[p];
    if (block && typeof block === 'object') {
      const iB = block.iB != null ? String(block.iB).trim() : '';
      const cB = block.cB != null ? String(block.cB).trim() : '';
      if (iB || cB) {
        return { checked: iB || null, cabin: cB || null };
      }
    }
  }
  return null;
}

/**
 * @param {object|null|undefined} priceInfo - one element of `totalPriceList`
 * @returns {Record<string, { checked: string|null, cabin: string|null }>|null}
 */
export function tripBaggageBySegmentFromPriceInfo(priceInfo) {
  const tbi = priceInfo?.tai?.tbi;
  if (!tbi || typeof tbi !== 'object') return null;
  const out = {};
  for (const [segId, rows] of Object.entries(tbi)) {
    if (!Array.isArray(rows) || rows.length === 0) continue;
    const merged = _mergeTbiPaxRow(rows[0]);
    if (merged && (merged.checked || merged.cabin)) {
      out[String(segId)] = merged;
    }
  }
  return Object.keys(out).length ? out : null;
}

/**
 * Prefer `tai.tbi` for this segment id, then segment `fD.bI`, then flight-level strings.
 * @returns {{ checked: string|null, cabin: string|null }}
 */
export function resolveTripjackSegmentBaggage(segment, displayFlight, flightData) {
  const sid = segment?.id != null && segment?.id !== '' ? String(segment.id) : '';
  let checked = null;
  let cabin = null;
  if (sid && displayFlight?.tripBaggageBySegmentId) {
    const row = displayFlight.tripBaggageBySegmentId[sid];
    if (row) {
      if (row.checked) checked = row.checked;
      if (row.cabin) cabin = row.cabin;
    }
  }
  const segBI = segment?.fD?.bI;
  if (!checked) {
    checked =
      segment?.ssrInfo?.BAGGAGE?.[0]?.desc ||
      segBI?.iB ||
      displayFlight?.baggage ||
      flightData?.baggage ||
      null;
  }
  if (!cabin) {
    cabin = segBI?.cB || displayFlight?.cabinBaggage || flightData?.cabinBaggage || null;
  }
  return { checked, cabin };
}
